/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.DataTable')
    .directive('accPagination', [function() {
    return {
        template: '<div class="pagination-wrapper" ng-class="{full: pagination.lastPage() > 1}">\
        <div class="btn-group dropup per-page col-lg-4">\
            <button class="btn btn-default btn-sm dropdown-toggle" data-toggle="dropdown">\
                <strong>{{"%{per_page} per page" | translate:{per_page: pagination.getPerPage()} }}</strong>\
                <span class="caret"></span>\
            </button>\
            <ul class="dropdown-menu">\
                <li ng-repeat="perPage in pagination.perPageOptions">\
                    <a ng-click="changePerPage(perPage)" data-length="{{perPage}}" href>{{perPage}}</a>\
                </li>\
            </ul>\
        </div>\
\
        <div class="pagination col-lg-8" ng-show="pagination.lastPage() > 1">\
            <ul class="pagination">\
                <li ng-class="{disabled: pagination.getPage() == pagination.firstPage()}"><a href ng-click="changePage(pagination.firstPage())"><i class="icon icon-backward"></i></a></li>\
                <li ng-class="{disabled: pagination.getPage() == pagination.firstPage()}"><a href ng-click="changePage(pagination.getPrevious())"><i class="icon icon-chevron-left"></i></a></li>\
            </ul>\
\
            <ul class="pagination pagination-numbered" ng-show="pagination.lastPage() > 1">\
                <li ng-repeat="page in pagination.getPages()" ng-class="{active: page == pagination.getPage()}">\
                    <a href ng-click="changePage(page)" data-page="{{page}}">{{page}}</a>\
                </li>\
            </ul>\
\
            <ul class="pagination" ng-show="pagination.lastPage() > 1">\
                <li ng-class="{disabled: pagination.getPage() == pagination.lastPage()}"><a href ng-click="changePage(pagination.getNext())"><i class="icon icon-chevron-right"></i></a></li>\
                <li ng-class="{disabled: pagination.getPage() == pagination.lastPage()}"><a href ng-click="changePage(pagination.lastPage())"><i class="icon icon-forward"></i></a></li>\
            </ul>\
        </div>\
        </div>\
        <div class="clearfix"></div>',
        controller: (['$scope', function($scope) {
            $scope.table.concatEntries = false;
        }])
    }
}]);
